function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.78313 3.77082L0.218667 1.06373C-0.0799925 0.815004 -0.0715309 0.38726 0.236776 0.148292C0.498465 -0.0545418 0.887191 -0.0486536 1.14117 0.16199L3.5 2.68977L5.85883 0.16199C6.11281 -0.048654 6.50154 -0.0545416 6.76322 0.148292C7.07153 0.38726 7.07999 0.815004 6.78133 1.06373L4.21687 3.77082C4.21687 3.77082 3.9237 4 3.5 4C3.0763 4 2.78313 3.77082 2.78313 3.77082Z",
  fill: "#626262"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.78313 3.77082L0.218667 1.06373C-0.0799925 0.815004 -0.0715309 0.38726 0.236776 0.148292C0.498465 -0.0545418 0.887191 -0.0486536 1.14117 0.16199L3.5 2.68977L5.85883 0.16199C6.11281 -0.048654 6.50154 -0.0545416 6.76322 0.148292C7.07153 0.38726 7.07999 0.815004 6.78133 1.06373L4.21687 3.77082C4.21687 3.77082 3.9237 4 3.5 4C3.0763 4 2.78313 3.77082 2.78313 3.77082Z",
  fill: "#69707D"
});

const SvgCollapse = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 7,
    height: 4,
    viewBox: "0 0 7 4",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgCollapse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/collapse.6eaa7ca5.svg";
export { ForwardRef as ReactComponent };